var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsParcsColored(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#c51b8a;}.cls-2{opacity:0.2;}.cls-3{fill:none;stroke:#202349;stroke-linecap:round;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_4",
    "data-name": "Calque 4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.05,
    y: 20.65,
    width: 19.7,
    height: 19.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.76,
    y: 0.96,
    width: 19.7,
    height: 19.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "afd93aa1-f475-4971-aea1-7d42c7265645"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3.12,
    y1: 31.96,
    x2: 7.35,
    y2: 33.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20,36.49h6.48a2.11,2.11,0,0,0,2.11-2.11V17.61a.09.09,0,0,1,.18,0l4.54,18.07a.83.83,0,0,0,1,.59l2.54-.73a.83.83,0,0,0,.58-1L32.79,13.78a7.31,7.31,0,0,0-7.12-5.7H14.33a7.31,7.31,0,0,0-7.12,5.7L2.54,34.54a.83.83,0,0,0,.58,1l2.54.73a.83.83,0,0,0,1-.59l4.54-18.07a.09.09,0,0,1,.18,0V34.38a2.11,2.11,0,0,0,2.11,2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.93,8.08V6a2.45,2.45,0,0,0-2.44-2.45h-5A2.45,2.45,0,0,0,15.07,6V8.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "28.59 33.02 20 33.02 11.41 33.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.88,
    y1: 31.96,
    x2: 32.65,
    y2: 33.02
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "28.59 20.68 26.49 19.13 23.38 21.14 20 19.13 16.62 21.14 13.51 19.13 11.41 20.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "28.59 23.84 26.49 22.28 23.38 24.29 20 22.28 16.62 24.29 13.51 22.28 11.41 23.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "28.59 26.99 26.49 25.43 23.38 27.45 20 25.43 16.62 27.45 13.51 25.43 11.41 26.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "28.59 30.14 26.49 28.59 23.38 30.6 20 28.59 16.62 30.6 13.51 28.59 11.41 30.14"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsParcsColored);
export default __webpack_public_path__ + "static/media/icons_parcs_colored.6f16549ad406e559141fb81295e32e44.svg";
export { ForwardRef as ReactComponent };